var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTg = function SvgTg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tg_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 12.5c0 6.627 5.373 12 12 12s12-5.373 12-12-5.373-12-12-12-12 5.373-12 12",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADB1B8",
    fillRule: "evenodd",
    d: "m15.974 17.007 1.745-7.642q.108-.486-.126-.695-.23-.209-.61-.077l-10.26 3.672q-.348.122-.47.275-.126.155-.029.292.094.138.379.216l2.626.76 6.092-3.56q.25-.155.379-.066.082.053-.046.163l-4.928 4.137-.193 2.514q.276 0 .537-.244l1.28-1.145 2.66 1.817q.76.398.964-.417",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0z"
  })))));
};
export default SvgTg;